export default __webpack_public_path__ + "static/media/bosch.a4abda59.png";